export default __webpack_public_path__ + "4f1cf94616eaffd7a18834a8afeae8ad.png";